import Auth from "../Auth";
import axios from "axios";
import constant from "../../configs/constant";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";

const URL = constant.serverUrl;
const notiCountData = 0;
const MySwal = withReactContent(Swal);
const serverCall = async (config) => {
  //header authorization
  // const token = config.acsessType;
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    // "authorization": `Bearer ${token}`,
    "Content-Type": config.contentType,
    "X-Application-Version": appVersions,
    Accept: config.accept,
  };
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: "net work error",
          status: 500,
        };
      }

      return Promise.reject(error);
    }
  );
  config.baseURL = URL;
  return axios(config);
};

const serverCallTech = async (config) => {
  //header authorization
  const token = JSON.parse(localStorage.getItem("auth"));
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    "Content-Type": config.contentType,
    Accept: config.accept,
  };
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      var VersionsServer = response?.headers["x-application-version"];
      if (parseInt(appVersions) === parseInt(VersionsServer)) {
        return response;
      } else {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        Swal.fire({
          position: "middle",
          icon: "warning",
          title:
            "Great News !<br> Your application has been updated with new features since you last logged in. <br> Kindly wait while you are redirected to the login page",
          showConfirmButton: false,
          timer: 5000,
          width: 600,
          allowOutsideClick: false,
        });
        setInterval(function () {
          Auth.logout();
        }, 5000);
      }
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: "net work error",
          status: 500,
        };
      }

      return Promise.reject(error);
    }
  );
  config.baseURL = URL;
  return axios(config);
};

const serverCallCust = async (config) => {
  //header authorization
  const token = JSON.parse(localStorage.getItem("auth"));
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    "Content-Type": config.contentType,
    Accept: config.accept,
  };
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      var VersionsServer = response?.headers["x-application-version"];
      if (parseInt(appVersions) === parseInt(VersionsServer)) {
        return response;
      } else {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        Swal.fire({
          position: "middle",
          icon: "warning",
          title:
            "Great News !<br> Your application has been updated with new features since you last logged in. <br> Kindly wait while you are redirected to the login page",
          showConfirmButton: false,
          timer: 5000,
          width: 600,
          allowOutsideClick: false,
        });
        setInterval(function () {
          Auth.logout();
        }, 5000);
      }
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: "net work error",
          status: 500,
        };
      }
      return Promise.reject(error);
    }
  );
  config.baseURL = URL;
  return axios(config);
};

const serverCallWork = async (config) => {
  //header authorization
  const token = JSON.parse(localStorage.getItem("auth"));
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    "Content-Type": config.contentType,
    Accept: config.accept,
  };
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      var VersionsServer = response?.headers["x-application-version"];
      if (parseInt(appVersions) === parseInt(VersionsServer)) {
        return response;
      } else {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        Swal.fire({
          position: "middle",
          icon: "warning",
          title:
            "Great News !<br> Your application has been updated with new features since you last logged in. <br> Kindly wait while you are redirected to the login page",
          showConfirmButton: false,
          timer: 5000,
          width: 600,
          allowOutsideClick: false,
        });
        setInterval(function () {
          Auth.logout();
        }, 5000);
      }
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: "net work error",
          status: 500,
        };
      }
      return Promise.reject(error);
    }
  );
  config.baseURL = URL;
  return axios(config);
};

const serverCallOther = async (config) => {
  console.log(config.skipAuth); // Check if skipAuth is passed correctly

  // Get token and app version
  const token = JSON.parse(localStorage.getItem("auth"));
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);

  // Set headers
  config.headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": config.contentType,
    Accept: config.accept,
  };

  // Interceptor to handle network errors
  axios.interceptors.response.use(
    (response) => {
      var VersionsServer = response?.headers["x-application-version"];
      if (parseInt(appVersions) === parseInt(VersionsServer)) {
        return response;
      } else {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        Swal.fire({
          position: "middle",
          icon: "warning",
          title:
            "Great News!<br>Your application has been updated with new features.<br>Redirecting to login...",
          showConfirmButton: false,
          timer: 5000,
          width: 600,
          allowOutsideClick: false,
        });
        setInterval(() => {
          Auth.logout();
        }, 5000);
      }
    },
    function (error) {
      // Check for 401 errors and if the config has `skipAuth` set to true
      if (
        error.response &&
        error.response.status === 401 &&
        error.config?.skipAuth !== true // Use error.config to access the original request config
      ) {
        Auth.logout();
      }
      return Promise.reject(error);
    }
  );

  config.baseURL = URL;
  return axios(config);
};

// export default serverCall

export const Getlogin = (bodyData) => {
  var bodyDataMain = {
    username: bodyData.username,
    password: bodyData.password,
    scope: bodyData.scope,
  };
  var formBody = [];
  for (var submitData in bodyDataMain) {
    var encodedKey = encodeURIComponent(submitData);
    var encodedValue = encodeURIComponent(bodyData[submitData]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&");
  return serverCall({
    method: "POST",
    url: "login/",
    data: formBody,
    accept: "application/json",
    contentType: "application/x-www-form-urlencoded;charset=UTF-8",
  })
    .then((res) => {
      if (res.status === 200) {
        var tokendata = res.data.access_token;
        localStorage.setItem("auth", JSON.stringify(res.data.access_token));
        // sessionStorage.setItem('authpost', JSON.stringify(res.data.access_token));
        // Auth.setUserToken(res.data.access_token);
        var decoded = jwt_decode(res.data.access_token);
        var userpermisson = decoded.user_permissions;
        var user_tenant = decoded.user_tenant;
        var userpermissonData = [];
        var currentData = new Date();
        for (var i = 0; i < userpermisson.length; i++) {
          var ApplicationPermissions = userpermisson[i].ApplicationPermissions;
          for (var j = 0; j < ApplicationPermissions.length; j++) {
            var userpermissonMain = {};
            userpermissonMain.ApplicationCode =
              userpermisson[i].ApplicationCode;
            userpermissonMain.ApplicationPermissionValue =
              ApplicationPermissions[j].ApplicationPermissionValue;
            userpermissonMain.PermissionCode =
              ApplicationPermissions[j].PermissionCode;
            userpermissonData.push(userpermissonMain);
          }
        }
        var accsessData = {
          accesstoken: res.data.access_token,
          userdata: decoded,
          tokendata: currentData,
          appver: constant.appVersions,
          userpermisson: userpermisson,
        };

        localStorage.setItem("access_token", JSON.stringify(accsessData));
        localStorage.setItem("permissions", JSON.stringify(userpermissonData));
        localStorage.setItem("user_tenant", JSON.stringify(user_tenant));

        if (user_tenant.length > 1) {
          var sendData = {
            techId: decoded.user_id,
          };

          const fetchResetPassword = async () => {
            try {
              const responsenotificationCount = await getExpirePassword();

              // If the response condition for password expiry is met, navigate to "/change-password"
              if (responsenotificationCount) {
                // Set redirected to true to prevent further redirects
                // window.location.href = "/change-password";
                var redirectData = "/change-password";
              } else {
                var redirectData = "/create-job";
              }
            } catch (error) {
              console.log("Error fetching password expiration:", error);
            }
          };

          fetchResetPassword();
          // var redirectData = "/create-job";
          // const fetchLogin = async () => {
          //   var notificationData = await getNotification(sendData);
          //   if(notificationData.UnreadCount > 0){
          //         redirectData = "/notification-front";
          //   }
          //   getSiteId(tokendata,decoded.user_id);
          //   getTypeofWork(tokendata,bodyData.username);
          //   getProfile(decoded.user_id)
          //   setInterval(function () {
          //     window.location.href = redirectData;
          //   }, 1000);
          // }
          // fetchLogin();

          // getSiteId(tokendata,decoded.user_id);
          // getTypeofWork(tokendata,bodyData.username);
          // getProfile(decoded.user_id);
          // getNotification(sendData);
          // setInterval(function () {
          // window.location.href = redirectData;
          // }, 1000);
        } else {
          var selected_tenant = {
            ApplicationTenantID: user_tenant[0].ApplicationTenantID,
            Tenant: user_tenant[0].Tenant,
          };
          localStorage.setItem(
            "selected_tenant",
            JSON.stringify(selected_tenant)
          );

          var sendData = {
            techId: decoded.user_id,
          };

          const fetchResetPassword = async () => {
            try {
              const responsenotificationCount = await getExpirePassword();

              // If the response condition for password expiry is met, navigate to "/change-password"
              if (responsenotificationCount) {
                // Set redirected to true to prevent further redirects
                // window.location.href = "/change-password";
                window.location.href = "/change-password";
              } else {
                window.location.href = "/create-job";
              }
            } catch (error) {
              console.log("Error fetching password expiration:", error);
            }
          };

          fetchResetPassword();
          //  var redirectData = "/create-job";
          // getSiteId(tokendata,decoded.user_id);
          // getTypeofWork(tokendata,bodyData.username);
          // getProfile(decoded.user_id);
          // getNotification(sendData);
          // setInterval(function () {
          //  window.location.href = redirectData;
          // }, 5000);
          //   const fetchLogin = async () => {
          //     var notificationData = await getNotification(sendData);
          //     if(notificationData.UnreadCount > 0){
          //           redirectData = "/notification-front";
          //     }
          //     getSiteId(tokendata,decoded.user_id);
          //     getTypeofWork(tokendata,bodyData.username);
          //     getProfile(decoded.user_id);
          //     getNotification(sendData);
          //     setInterval(function () {
          //       window.location.href = redirectData;
          //     }, 1000);
          // }
          // fetchLogin();
        }
        // window.location.href = constant.serverUrl+"create-job";
        return true;
      } else {
        MySwal.fire("<p>Incorrect username or password, please try again!<p>");
        return 1;
      }
    })
    .catch((err) => {
      const condition = navigator.onLine ? "online" : "offline";
      if (condition === "offline") {
        MySwal.fire(
          "<p>You are currently offline. Please connect to internet and try again!<p>"
        );
        return 1;
      } else {
        MySwal.fire("<p>Incorrect username or password, please try again!<p>");
        console.log(err.message);
        return 1;
      }
    });
};

export const getCreateJob = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "jobs/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Job has been created successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
        return res;
      }
    })
    .catch((err) => {
      const condition = navigator.onLine ? "online" : "offline";
      if (err.message === "Network Error") {
        if (condition === "offline") {
          const min = 1;
          const max = 100;
          const rand = min + Math.random() * (max - min);
          var cacheName = "thejoCaches" + rand;
          var url = "http://127.0.0.1:8080";
          var response = bodyData;

          // const addDataIntoCache = (cacheName, url, bodyData) => {
          // Converting our response into Actual Response form
          const data = new Response(JSON.stringify(response));

          // if ('caches' in window) {
          // Opening given cache and putting our data into it
          caches.open(cacheName).then((cache) => {
            cache.put(url, data);
            var attempts = localStorage.getItem("unsyu");
            if (
              attempts === "" &&
              attempts === null &&
              attempts === undefined
            ) {
              localStorage.setItem("unsyu", 1);
            } else {
              var attemptsval = localStorage.getItem("unsyu");
              localStorage.setItem("unsyu", ++attemptsval);
            }
          });
          Swal.fire({
            icon: "success",
            title: "Success",
            allowOutsideClick: false,
            confirmButtonColor: "#ff726f",
            text: "Job has been created successfully in offline mode",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
          var msg = err.response.data.errors;
          Swal.fire({
            icon: "error",
            title: err.response.status,
            allowOutsideClick: false,
            text: msg,
          }).then((result) => {
            // if (result.isConfirmed) {
            //   window.location.reload();
            // }
          });
          // MySwal.fire('<p>Something went wrong, please try again<p>');
          console.log("err", err);
        }
        // }
        // };
      } else {
        var msg = err.response.data.errors;
        Swal.fire({
          icon: "error",
          title: err.response.status,
          allowOutsideClick: false,
          text: msg,
        }).then((result) => {
          // if (result.isConfirmed) {
          //   window.location.reload();
          // }
        });
        // MySwal.fire('<p>Something went wrong, please try again<p>');
        console.log("err", err);
      }
    });
};

export const getUpdateJob = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url:
      "jobs/" +
      bodyData.JobID +
      "/" +
      url +
      "?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Job has been updated successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getUpdateIncentive = (bodyData, JobID) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PATCH",
    url:
      "jobs/" +
      JobID +
      "/incentive/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const changePassword = async (bodyData) => {
  let ApplicationTenantID = 0;
  const accessSelectedTenant = localStorage.getItem("selected_tenant");

  if (accessSelectedTenant) {
    const readDataSelected = JSON.parse(accessSelectedTenant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }

  try {
    const res = await serverCallOther({
      method: "PATCH",
      url: `users/${bodyData.cusId}/changepassword/?existing_password=${bodyData.currentPassword}&new_password=${bodyData.newPassword}&confirm_new_password=${bodyData.confirmNewPassword}&applicationName=Splice`,
      // data: bodyData,
      accept: "application/json",
      contentType: "application/json",
      skipAuth: true,
    });

    console.log("res", res);

    // Handle success response
    if (res.data && res.data.success) {
      return res.data; // Return success
    } else {
      // If the response doesn't contain the 'success' field, show an error
      MySwal.fire("<p>Something went wrong, please try again</p>");
    }
  } catch (err) {
    console.log("Error:", err);

    if (err.response && err.response.status === 401) {
      // Handle 401 error specifically

      const msg = err.response?.errors || "Incorrect username or password.";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: msg,
        allowOutsideClick: false,
      });
    } else {
      const msg = err.response?.data?.errors || "Something went wrong.";
      Swal.fire({
        icon: "error",
        title: err.response?.status || "Error",
        text: msg,
        allowOutsideClick: false,
      });
      console.log("Error details:", err);
    }
  }
};

export const getUpdateAllowance = (bodyData, JobAllowanceID) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url:
      "joballowances/" +
      JobAllowanceID +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getAddTechnician = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "joballowances/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const addNotification = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "splice/notifications/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSubmitIncentive = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "sites/sitestatus/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobsAuth = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url:
      "jobs/bulkauthorize/?auth_date=" +
      bodyData.auth_date +
      "&site_id=" +
      bodyData.site_id +
      "&modified_by=" +
      bodyData.modified_by +
      "&current_status=" +
      bodyData.current_status +
      "&application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getCreateJobAsync = (bodyData, name) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "jobs/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        getSync();
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "All jobs have been collected for sync",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getAllCacheData = async () => {
  var url = "http://127.0.0.1:8080";
  // List of all caches present in browser
  var names = await caches.keys();

  var cacheDataArray = [];

  // Iterating over the list of caches
  names.forEach(async (name) => {
    // Opening that particular cache
    const cacheStorage = await caches.open(name);
    // Fetching that particular cache data
    const cachedResponse = await cacheStorage.match(url);
    var data = await cachedResponse.json();
    getCreateJobAsync(data, name);
    // Pushing fetched data into our cacheDataArray
    cacheDataArray.push(data);
  });
  return cacheDataArray;
};

export const getSync = async () => {
  var names = await caches.keys();
  names.forEach(async (name) => {
    localStorage.setItem("unsyu", 0);
    let text = name;
    const myArray = text.split("-");
    if (myArray[0] !== "workbox") {
      caches.delete(name);
    }
    var month = new Date().getMonth();
    var currentCount = parseInt(month);
    var monthData = currentCount + 1;
    var year = new Date().getFullYear();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    var sendData = {
      month: monthData,
      year: year,
      techId: cusId,
    };
    getJobs(sendData);
  });
};

export const getCustmor = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallCust({
    method: "GET",
    url:
      "sites/" +
      siteId +
      "/customers/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const customerData = res.data;
        const customerDataArr = [];
        if (
          customerData !== null &&
          customerData !== undefined &&
          customerData !== ""
        ) {
          const customerDataResp = customerData;
          for (var i = 0; i < customerDataResp.length; i++) {
            var customerDataMain = {};
            customerDataMain["CustomerSiteID"] =
              customerDataResp[i].CustomerSiteID;
            customerDataMain["CustomerName"] = customerDataResp[i].CustomerName;
            customerDataMain["CustomerID"] = customerDataResp[i].CustomerID;
            customerDataMain["SiteID"] = customerDataResp[i].SiteID;
            customerDataMain["SiteName"] = customerDataResp[i].SiteName;
            customerDataArr.push(customerDataMain);
          }
        }
        if (customerDataArr.length > 0) {
          localStorage.setItem("customerData", JSON.stringify(customerDataArr));
        }
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getJobs = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/count/?technician_id=" +
      bodyData.techId +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;
        const jobDataArr = [];
        if (jobData !== null && jobData !== undefined && jobData !== "") {
          const jobDataResp = jobData;
          for (var i = 0; i < jobDataResp.length; i++) {
            var jobDataMain = {};
            jobDataMain["JobType"] = jobDataResp[i].JobType;
            jobDataMain["JobCount"] = jobDataResp[i].JobCount;
            jobDataMain["JobTypeID"] = jobDataResp[i].JobTypeID;
            jobDataMain["IncentiveAmount"] = jobDataResp[i].IncentiveAmount;
            jobDataArr.push(jobDataMain);
          }
        }
        localStorage.setItem("jobCountData", JSON.stringify(jobDataArr));
        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getJobsAllowanceMyWork = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/JobAllowanceMywork/?technician_id=" +
      bodyData.techId +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&siteid=" +
      bodyData.siteID +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;
        // const jobDataArr = [];
        // if(jobData !== null && jobData !== undefined && jobData !==''){
        //     const jobDataResp = jobData;
        //     for(var i = 0; i < jobDataResp.length; i++) {
        //       var jobDataMain = {};
        //       jobDataMain['JobType'] = jobDataResp[i].JobType;
        //       jobDataMain['JobCount'] = jobDataResp[i].JobCount;
        //       jobDataMain['JobTypeID'] = jobDataResp[i].JobTypeID;
        //       jobDataMain['IncentiveAmount'] = jobDataResp[i].IncentiveAmount;
        //       jobDataArr.push(jobDataMain);
        //   }
        // }
        // localStorage.setItem('jobCountData',JSON.stringify(jobDataArr));
        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServiceReport = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/?site_id=" +
      bodyData.siteId +
      "&datefrom=" +
      bodyData.startDate +
      "&dateto=" +
      bodyData.endDate +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const savePickJobs = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: "servicereport/Pick/",
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Pick list generated successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServicePickJobs = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/PickList/?site_id=" +
      bodyData.siteId +
      "&datefrom=" +
      bodyData.startDate +
      "&dateto=" +
      bodyData.endDate +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const savePickListJob = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: "servicereport/Save/",
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "SR saved successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const generatePickListJob = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: "servicereport/Update Generate SR Job/",
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "SR generated successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServicePickJobsData = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/" +
      bodyData.pick_id +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getExpirePassword = (bodyData, siteId) => {
  var user = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  const selectedUser = localStorage.getItem("access_token");

  if (
    selectedUser !== "" &&
    selectedUser !== null &&
    selectedUser !== undefined
  ) {
    const readDataSelected = JSON.parse(selectedUser);
    user = readDataSelected.userdata.sub;
  }

  return serverCallOther({
    method: "GET",
    url: `/users/${user}/forcepwdchange/`,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return jobData;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const deletePickJob = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "DELETE",
    url:
      "servicereport/" +
      bodyData.pick_list_id +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been deleted successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const deleteGeneratedJob = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "DELETE",
    url:
      "servicereport/" +
      bodyData.sr_id +
      "/SR Delete/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been deleted successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServiceGeneratedJobs = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/Generated/?site_id=" +
      bodyData.siteId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServicegeneratedJobsData = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/" +
      bodyData.sr_id +
      "/generatedsr/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return res.data;
      }
    })
    .catch((err) => {
      console.log("errorrrrr", err);
      var msg = err.response?.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getUploadDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "documents/?application_tenant_id=" + ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getDocumentSelectId = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/common/selections/?selection_type=" +
      bodyData.selectionType +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const documentsUpload = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "documents/upload/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "multipart/form-data",
    contentType: "multipart/form-data",
  })
    .then((res) => {
      if (res.status === 201) {
        // MySwal.fire('<p>Prospect has been cretated successfully<p>');
        return res.data;
      } else {
        // MySwal.fire('<p>Something went wrong, please try again<p>');
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const saveGeneratedJob = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: `servicereport/SaveSigned/?application_tenant_id=${ApplicationTenantID}`,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Signed SR uploaded successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const signedGeneratedJob = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: `servicereport/Signed/?application_tenant_id=${ApplicationTenantID}`,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Signed SR uploaded successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServiceSignedJobs = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/SignedHome/?site_id=" +
      bodyData.siteId +
      "&CustomerID=" +
      bodyData.CustomerID +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServicePickSignedJobs = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/invoicesr/?sr_ids=" +
      bodyData.sr_ids +
      "&modifiedby=" +
      bodyData.ModifiedBy +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const saveSignedJob = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: `servicereport/Invoice SR/`,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Invoice generated successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServiceInvoicedJobs = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/Invoice/?site_id=" +
      bodyData.siteId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getPickListPreview = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/" +
      bodyData.id +
      "/preview/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getGeneratedListPreview = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/" +
      bodyData.id +
      "/generatepreview/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      console.log("resssss", res);
      if (res.status === 200) {
        const jobData = res.data;

        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getInvoicedListPreview = (bodyData) => {
	
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/" +
      bodyData.id +
      "/invoicepreview/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      console.log("resssss", res);
      if (res.status === 200) {
        const jobData = res.data;

        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getNotification = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "splice/notifications/" +
      bodyData.techId +
      "/getnotificationmessage/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const notificationData = res.data;
        const notificationDataArr = [];
        if (
          notificationData !== null &&
          notificationData !== undefined &&
          notificationData !== ""
        ) {
          const notificationDataResp = notificationData;
          localStorage.setItem("notiCountData", notificationDataResp.length);
          for (var i = 0; i < notificationDataResp.length; i++) {
            var notificationDataMain = {};
            notificationDataMain["NotificationID"] =
              notificationDataResp[i].NotificationID;
            notificationDataMain["DisplayFromDate"] =
              notificationDataResp[i].DisplayFromDate;
            notificationDataMain["Notification"] =
              notificationDataResp[i].Notification;
            notificationDataMain["DeliveryFlag"] =
              notificationDataResp[i].DeliveryFlag;
            notificationDataMain["ReadFlag"] = notificationDataResp[i].ReadFlag;
            notificationDataArr.push(notificationDataMain);
          }
        } else {
          localStorage.setItem("notiCountData", 0);
        }

        localStorage.setItem(
          "notificationData",
          JSON.stringify(notificationDataArr)
        );
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobs = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/?site_id=" +
      bodyData.site_id +
      "&query_date=" +
      bodyData.date +
      "&status=" +
      bodyData.status +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        var site = {
          siteID: bodyData.site_id,
          date: bodyData.date,
        };
        // getTechnicians(bodyData, site);
        getTypeofWork(bodyData, bodyData.user_id);
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobsIncentive = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/incentive/" +
      bodyData.status_id +
      "/?site_id=" +
      bodyData.site_id +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobsSubmitIncentiveType = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/submitbutton/" +
      bodyData.status_id +
      "/?site_id=" +
      bodyData.site_id +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackUserDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "sites/" +
      bodyData.site_id +
      "/users/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackNotificationList = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/splice/notifications/" +
      bodyData.userId +
      "/getlistofnotification/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem("notiCountData", res.data.length);
        return res.data;
      } else {
        localStorage.setItem("notiCountData", 0);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackFullSite = () => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "sites/?application_tenant_id=" + ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackDateSite = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "users/" +
      bodyData.userid +
      "/minallocationdate/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackUserEdit = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "users/" +
      bodyData.userId +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const deputeUser = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PATCH",
    url:
      "/users/" +
      bodyData.userId +
      "/depute/?siteId=" +
      bodyData.siteId +
      "&fromDate=" +
      bodyData.fromDate +
      "&toDate=" +
      bodyData.toDate +
      "&modifiedBy=" +
      bodyData.modifiedBy +
      "&application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const transferUser = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PATCH",
    url:
      "/users/" +
      bodyData.userId +
      "/transfer/?siteId=" +
      bodyData.siteId +
      "&fromDate=" +
      bodyData.fromDate +
      "&modifiedBy=" +
      bodyData.modifiedBy +
      "&application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const terminateUser = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PATCH",
    url:
      "/users/" +
      bodyData.userId +
      "/terminate/?terminationDate=" +
      bodyData.terminationDate +
      "&modifiedBy=" +
      bodyData.modifiedBy +
      "&application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getNotificationStatusUpdate = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PATCH",
    url:
      "splice/notifications/" +
      bodyData.notificationID +
      "/" +
      bodyData.techId +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      // if(res.status === 200){
      //   MySwal.fire('<p>Data has been updated successfully<p>');
      //   // return res.status;
      //   }else{
      //     MySwal.fire('<p>Something went wrong, please try again<p>');
      //   }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const submitUser = (bodyData, userId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: "/users/" + userId + "/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
      return res.status;
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const UserAdd = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "/users/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const deleteSiteCustomer = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "DELETE",
    url:
      "customers/" +
      bodyData.customerId +
      "/?site_id=" +
      bodyData.SiteID +
      "&application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been delete successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const deleteCustomer = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "DELETE",
    url:
      "customers/" +
      bodyData.customerId +
      "/?site_id=" +
      bodyData.SiteID +
      "&application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been delete successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const addCustomer = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "/customers/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        // return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobsAllowance = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "joballowances/?site_id=" +
      bodyData.site_id +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&allowanceType=" +
      bodyData.status_id +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSubmitBtnAllowances = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "joballowances/submitbutton/?site_id=" +
      bodyData.site_id +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&allowanceType=" +
      bodyData.status_id +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackAllCustomer = () => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "customers/sap/?application_tenant_id=" + ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackCustmor = (siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallCust({
    method: "GET",
    url:
      "sites/" +
      siteId.site_id +
      "/customers/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackAllowanceTechnicians = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "joballowances/technicians/?site_id=" +
      bodyData.site_id +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&allowanceType=" +
      bodyData.status_id +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobsEdit = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/" +
      bodyData.jobid +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSiteDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/jobs/monthlyclosureinfo/?month_date=" +
      bodyData.month_date +
      "&user_id=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSiteDetailsThisco = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/jobs/monthlyclosurethiscoinfo/?month_date=" +
      bodyData.month_date +
      "&user_id=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSubmitButtonDetail = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/jobs/submitbutton/siteot/?site_id=" +
      bodyData.siteId +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackJobDates = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "users/" +
      bodyData.userid +
      "/pendingjobdates/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackSiteid = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "users/" +
      bodyData.userid +
      "/sites/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getThiscoCustomer = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "sites/" +
      bodyData.siteId +
      "/techniciansthisco/?allocationForDate=" +
      bodyData.date,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchThiscoCustomer = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/OThours/?site_id=" +
      bodyData.siteId +
      "&user_id=" +
      bodyData.userId +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&technician_id=" +
      bodyData.techId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchThiscoAllCustomer = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/OThoursSummary/?site_id=" +
      bodyData.siteId +
      "&user_id=" +
      bodyData.userId +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchSrStatics = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/JobsNotSR/?site_ids=" +
      bodyData.siteId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchSrGeneratedStatics = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/GeneratedSRStatistic/?site_ids=" +
      bodyData.siteId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchSrSignedStatics = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/SignedSRStatistic/?site_ids=" +
      bodyData.siteId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchSrInvoicedStatics = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/InvoicedSRStatistic/?site_ids=" +
      bodyData.siteId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const saveThiscoOtHour = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: "jobs/OTHours/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const submitThiscoOtHour = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "sites/sitestatus/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackBranchesById = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "splice/notifications/" +
      bodyData.userid +
      "/getbranches/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackTechByUserId = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "splice/notifications/" +
      bodyData.userid +
      "/gettechnicians/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getJobDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/summary/?technician_id=" +
      bodyData.cusId +
      "&jobtype_id=" +
      bodyData.jobtype_id +
      "&month=" +
      bodyData.month +
      "&year=" +
      bodyData.year +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getNotificationDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "splice/notifications/" +
      bodyData.notificationID +
      "/" +
      bodyData.techId +
      "/getnotificationdetail/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getNotificationCount = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "splice/notifications/" +
      bodyData.techId +
      "/getnotificationcount/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getProfile = (userId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "users/" +
      userId +
      "/profile/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem("profiledata", JSON.stringify(res.data));
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getTypeofWork = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallWork({
    method: "GET",
    url: "jobtypes/?application_tenant_id=" + ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const typeofWorkData = res.data;
        const typeofWorkDataArr = [];
        if (
          typeofWorkData !== null &&
          typeofWorkData !== undefined &&
          typeofWorkData !== ""
        ) {
          const typeofWorkDataResp = typeofWorkData;
          for (var j = 0; j < typeofWorkDataResp.length; j++) {
            var typeofWorkDataMain = {};
            typeofWorkDataMain["JobTypeID"] = typeofWorkDataResp[j].JobTypeID;
            typeofWorkDataMain["JobType"] = typeofWorkDataResp[j].JobType;
            typeofWorkDataMain["Materials"] = typeofWorkDataResp[j].Materials;
            typeofWorkDataMain["Measures"] = typeofWorkDataResp[j].Measures;
            typeofWorkDataArr.push(typeofWorkDataMain);
          }
        }
        localStorage.setItem("workData", JSON.stringify(typeofWorkDataArr));
        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSiteId = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "technicians/" +
      siteId +
      "/currentsite/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    // acsessType:bodyData
  })
    .then((res) => {
      if (res.status === 200) {
        // const fetchLogin = async () => {
        // var siteIdData = 0
        // if(res.data.SiteID !== null && res.data.SiteID !== ''){
        //   siteIdData = res.data.SiteID;
        // }
        // sessionStorage.setItem('siteID',siteIdData);
        // localStorage.setItem('siteID',siteIdData);
        // // setInterval(function () {

        // // }, 1000);
        // var site = {
        //   siteID :siteIdData,
        //   date : moment(new Date()).format('YYYY-MM-DD'),
        // };
        // getTechnicians(bodyData,site);
        // getCustmor(bodyData,siteIdData);
        return res;
        // }
        // fetchLogin();
      }
    })
    .catch((err) => {
      // var msg = err.response.data.errors;
      // Swal.fire({
      //   icon: 'error',
      //   title: err.response.status,
      //   allowOutsideClick:false,
      //   text: msg,
      // }).then((result) => {
      //   // if (result.isConfirmed) {
      //   //   window.location.reload();
      //   // }
      // })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getJobLog = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "jobs/" +
      bodyData.jobId +
      "/datachangelog/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      // var msg = err.response.data.errors;
      // Swal.fire({
      //   icon: 'error',
      //   title: err.response.status,
      //   allowOutsideClick:false,
      //   text: msg,
      // }).then((result) => {
      //   // if (result.isConfirmed) {
      //   //   window.location.reload();
      //   // }
      // })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getTechnicians = (bodyData, site) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallTech({
    method: "GET",
    url:
      "sites/" + site.siteID + "/technicians/?allocationForDate=" + site.date,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const techniciansDataArr = [];
        const techniciansDataResp = res.data;
        if (
          techniciansDataResp !== null &&
          (techniciansDataResp !== "") & (techniciansDataResp !== "")
        ) {
          for (var l = 0; l < techniciansDataResp.length; l++) {
            var techniciansDataMain = {};
            techniciansDataMain["name"] =
              techniciansDataResp[l].TechnicianName +
              "-" +
              techniciansDataResp[l].EmployeeID;
            techniciansDataMain["id"] = techniciansDataResp[l].TechnicianID;
            techniciansDataMain["EmployeeID"] =
              techniciansDataResp[l].EmployeeID;
            techniciansDataMain["IsTrainee"] = techniciansDataResp[l].IsTrainee;
            techniciansDataArr.push(techniciansDataMain);
          }
        }
        localStorage.setItem("techData", JSON.stringify(techniciansDataArr));
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getTechniciansJob = (bodyData) => {
	
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallTech({
    method: "GET",
    url: "jobs/Technicians/?job_id=" + bodyData.jobid,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const techniciansDataArr = [];
        const techniciansDataResp = res.data;
        if (
          techniciansDataResp !== null &&
          (techniciansDataResp !== "") & (techniciansDataResp !== "")
        ) {
          for (var l = 0; l < techniciansDataResp.length; l++) {
            var techniciansDataMain = {};
            techniciansDataMain["name"] =
              techniciansDataResp[l].DisplayName +
              "-" +
              techniciansDataResp[l].LoginID;
            techniciansDataMain["id"] = techniciansDataResp[l].TechnicianID;
            techniciansDataMain["EmployeeID"] = techniciansDataResp[l].LoginID;
            techniciansDataMain["IsTrainee"] = techniciansDataResp[l].IsTrainee;
            techniciansDataMain["IsValid"] = techniciansDataResp[l].IsValid;
            techniciansDataArr.push(techniciansDataMain);
          }
        }
        localStorage.setItem("techData", JSON.stringify(techniciansDataArr));
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const fetchWorkorderList = (customerId, JobId, JobType) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");

  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }

  return serverCallTech({
    method: "GET",
    url: "servicereport/Pending_wolist/?customerId=" + encodeURIComponent(customerId) + "&JobId=" + encodeURIComponent(JobId) + "&JobType= " + encodeURIComponent(JobType) + "&application_tenant_id=" + ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        const workOrderData = res.data;
        return Promise.all(workOrderData);
      }
    })
    .catch((err) => {
      var msg = err?.response?.data?.errors || "Failed to fetch workorders!";
      Swal.fire({
        icon: "error",
        title: err?.response?.status || "Error",
        allowOutsideClick: false,
        text: msg,
      });
      console.error("Error fetching workorders:", err);
    });
};

export const saveSignedJobWithWorkorder = (bodyData, url) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url: `servicereport/SaveSigned_WO/?application_tenant_id=${ApplicationTenantID}`,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          allowOutsideClick: false,
          text: "Invoice generated successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.reload();
          }
        });
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getServicePickJobsData_WO = (bodyData, siteId) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "servicereport/EditpicklistWO/?pick_list_id=" +	  
      bodyData.pick_id +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        const jobData = res.data;

        return Promise.all(res.data);
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const update_workorders = async (
  customerId,
  WorkOrderNumber,
  ItemCode,
  JobId_QTY,
  JobId_QTY_Edited,
  Quantity,
  Price,
  Linenum
) => {
  let ApplicationTenantID = 1;

  const accessselectedtenant = localStorage.getItem("selected_tenant");
  if (accessselectedtenant) {
    try {
      const readDataSelected = JSON.parse(accessselectedtenant);
      ApplicationTenantID = readDataSelected.ApplicationTenantID || 1;
    } catch (e) {
      console.warn("Failed to parse selected_tenant from localStorage", e);
    }
  }

  try {
    const token = JSON.parse(localStorage.getItem("access_token"))?.access_token;

    const res = await serverCallTech({
      method: "PUT",
      url: "servicereport/Update_wolist/?customerId=" + encodeURIComponent(customerId) + "&WorkOrder=" + encodeURIComponent(WorkOrderNumber) + "&application_tenant_id=" + encodeURIComponent(ApplicationTenantID) + "&ItemCode=" + encodeURIComponent(ItemCode) + "&JobId_QTY=" + encodeURIComponent(JobId_QTY) + "&JobId_QTY_Edited=" + encodeURIComponent(JobId_QTY_Edited) + "&WorkOrder_Qty=" + encodeURIComponent(Quantity) + "&Price=" + encodeURIComponent(Price)+ "&Linenum=" + encodeURIComponent(Linenum),
      data: {}, // backend PUT may require body
      accept: "application/json",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res && (res.status === 200 || res.status === 204)) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Workorder updated successfully!",
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Notice",
        text: "Update succeeded but returned no data.",
      });
    }
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Failed to update workorder!",
      text: err.message || "Unexpected error occurred.",
    });
  }
};


export const delete_picklist_job = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "DELETE",
    url:
      "servicereport/delete_picklist_job/" +
      "?pick_list_id=" + bodyData.pick_list_id +
      "&JobId=" + bodyData.JobId +
      "&application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been deleted successfully<p>");
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
      });
      console.log("err", err);
    });
};